import { BlogSection } from '@/types/blog';

export const fuehrungGefuehlSection: BlogSection = {
  id: 'fuehrung-gefuehl',
  title: 'Führung braucht Gefühl',
  content: `
    <p>
      Im Business zeigt sich, wie weit wir gekommen sind. Viele Unternehmen fördern Menschen, die „Zahlen liefern", aber Zahlen ohne Haltung sind gefährlich. Wir brauchen eine neue Generation von Führungskräften, die nicht nur KPI-Tracker, sondern Menschenkenner und Beziehungsarchitekten sind.
    </p>
  `
};
